module.exports = __webpack_public_path__ + "static/media/review.bf66b559.png";